import * as Globals from "../Globals";
import axios from "axios";
import { load } from "../state/appSlice";
import { Logout } from "./LoginActions";
export function GetAppSettings(dispatch) {
  axios.get(`${Globals.baseUrl}/Login/GetAppSettings`, {
    headers: { "content-type": "application/json; charset=utf-8" }
  }).then((res) => {
    if (res.status === 200) {
      console.log("GetAppSettings");
      dispatch(load(res.data));
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
